<template>
  <div class="activation">
    <div class="question">{{ $t('promotion_new.activated_how') }}</div>
    <div class="radios">
      <div class="radio">
        <input id="chk_code" type="radio" :value="true" v-model="hasCode">
        <label for="chk_code">{{ $t('promotion_new.code') }}</label>
      </div>
      <div class="radio">
        <input id="chk_auto" type="radio" :value="false" v-model="hasCode">
        <label for="chk_auto">{{ $t('promotion_new.auto') }}</label>
      </div>
    </div>
    <template v-if="hasCode">
      <div class="question">{{ $t('promotion_new.enter_code') }}</div>
      <input type="text" v-model="promotion.code">
    </template>
  </div>
</template>

<script>
export default {
  name: "PromotionActivation",

  props: {
    promotion: Object
  },

  data() {
    return {
      hasCode: false
    }
  },

  mounted() {
    if (this.promotion && this.promotion.code) {
      this.hasCode = true;
    }
    this.emitHasCode();
  },

  watch: {
    hasCode() {
      this.emitHasCode();
    }
  },

  methods: {
    emitHasCode() {
      this.$emit("hasCode", this.hasCode);
    }
  }
}
</script>